import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_INTRODUCTIONS_REQUEST } from "./constants";
import { Action, IndroductionsState } from "./types";

function items(state: IndroductionsState = {}, action: Action): IndroductionsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_INTRODUCTIONS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_INTRODUCTIONS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_INTRODUCTIONS_REQUEST):
    case getFailureActionType(FETCH_INTRODUCTIONS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const introductions = combineReducers({ items, isFetching });
